import React, { useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import LinkButton from "../utils/LinkButton";

function BibleStudyItems(props) {
  const xframeObject = (xframe) => {
    props.setXframe(xframe);
  };
  const embedObject = (file) => {
    props.setFile(file);
  };
  
  
  return (
    <Container>
      <Col>
        {props.bibleStudyItemsList.map((item) => {
          if(item.url != undefined){
            return (
              <Row key={item.id} style={{ marginTop: "25px" }}>
                <Card
                  onClick={() => xframeObject(item.url)}
                  style={{ padding: "5px" }}
                >
                  <LinkButton
                    buttonWidth="100%"
                    buttonHeight="88px"
                    buttonFontSize="26px"
                    title={item.name}
                  />
                </Card>
              </Row>
            );
          }else{
            return (
              <Row key={item.id} style={{ marginTop: "25px" }}>
                <Card
                  onClick={() => embedObject(item.file)}
                  style={{ padding: "5px" }}
                >
                  <LinkButton
                    buttonWidth="100%"
                    buttonHeight="88px"
                    buttonFontSize="26px"
                    title={item.name}
                  />
                </Card>
              </Row>
            )
          }
          
        })}
      </Col>
    </Container>
  );
}
export default BibleStudyItems;
